export default function PostContentEdit() {
	return 'Post Content Placeholder';
}
